/*
 * Copyright (c) 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */

export enum TSRechtsform {
    NATUERLICHE_PERSON = <any> 'NATUERLICHE_PERSON',
    GENOSSENSCHAFT = <any> 'GENOSSENSCHAFT',
    ANDERE_KOERPERSCHAFT = <any> 'ANDERE_KOERPERSCHAFT',
    MEHRPERSONENGESELLSCHAFT = <any> 'MEHRPERSONENGESELLSCHAFT',
}

export function getAllTSRechtsformValues(): Array<TSRechtsform> {
    return [
        TSRechtsform.NATUERLICHE_PERSON,
        TSRechtsform.GENOSSENSCHAFT,
        TSRechtsform.MEHRPERSONENGESELLSCHAFT,
        TSRechtsform.ANDERE_KOERPERSCHAFT
    ];
}

export function getTSRechtsformValues(): Array<TSRechtsform> {
    return [
        TSRechtsform.NATUERLICHE_PERSON,
        TSRechtsform.GENOSSENSCHAFT,
        TSRechtsform.MEHRPERSONENGESELLSCHAFT,
    ];
}

export function getTSRechtsformValuesForZweitpersonGrundeigentuemer(): Array<TSRechtsform> {
    return getAllTSRechtsformValues();
}






// WEBPACK FOOTER //
// ./src/app/models/enums/TSRechtsform.ts